import { fetchApi } from "./fetchApi";

export async function read({
  id,
  change,
  context,
  company_id,
  model = "crm.lead",
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [typeof id === "number" ? [id] : id, change],
      model: model,
      method: "read",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],
          params: {
            cids: company_id,
            id: "",
            model: model,
            view_type: "form",
          },
          default_type: "opportunity",
          search_default_assigned_to_me: 1,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/${model}/read`,
  });
}
